<h3>{{ getMigratingFromHeader() }}</h3>
<cb-table
    *cbWaitFor="lots"
    class="cb-margin-top cb-margin-bottom-3x flex"
    [loaded]="true"
>
    <thead cbTableHead>
    <tr>
        <td></td>
        <td>Lot #</td>
        <td>Address</td>
        <td>Lot Type</td>
        <td>Floor Area</td>
        <td>Job #</td>
        <td>Job Status</td>
    </tr>
    </thead>
    <tbody cbTableBody>
        @for (lot of lots | cbSortByPipe: 'lotNumber' : 'asc'; track lot) {
            <tr cbTableRow>
                <td>
                    @if (lot.specTemplateId > 0) {
                        <mat-icon class="cb-grey">photo</mat-icon>
                    }
                </td>
                <cb-td-text [value]="lot.lotNumber"></cb-td-text>
                <td>
                    {{ lot.lotAddress.street }}
                    <br />
                    {{ lot.lotAddress.suburb }}
                </td>
                <td>
                    {{ LOT_TYPE_ENUM[lot.lotType] }}
                    @if (lot.buildType.label) {
                        <span>({{ lot.buildType.code }})</span>
                    }
                    <br />
                    {{ LOT_CONTRACT_TYPE_ENUM[lot.contractType] }}
                </td>
                <td>{{ lot.amenities.floorArea }} m2</td>
                <cb-td-text [value]="lot.jobNumber"></cb-td-text>
                <cb-td-text [value]="LOT_JOB_STATUS_ENUM[lot.jobStatus]"></cb-td-text>
            </tr>
        }
    </tbody>
</cb-table>
